export const SpaceMultiple = 8

export type SpacerMultiplier = 0 | 1 | 2 | 3 | 4 | 5 | 7 | 10 | 13 | 18

interface FixedSpacerProps {
  multiplier: SpacerMultiplier
}

export const FixedSpacer = (props: FixedSpacerProps) => {
  if (!props.multiplier) {
    return null
  }

  return <div style={{ height: `${props.multiplier * SpaceMultiple}px`, flexShrink: 0 }} />
}

interface ResponsiveSpacerProps {
  minMultiplier: SpacerMultiplier
  maxMultiplier: SpacerMultiplier
}

export const ResponsiveSpacer = (props: ResponsiveSpacerProps) => {
  const { minMultiplier, maxMultiplier } = props
  const maxHeight = maxMultiplier * SpaceMultiple
  const minHeight = minMultiplier * SpaceMultiple
  const height = maxHeight * 0.1

  return (
    <div style={{ maxHeight: `${maxHeight}px`, minHeight: `${minHeight}px`, height: `${height}vw`, flexShrink: 0 }} />
  )
}
